import {Button, ComponentStyle, Form, Formik, FormikControl, InputError, PageStyle, CONSTANTS, useState, useRef, RejectModalStyle} from '@/imports-files/components/model/rejection-modal';

export function AddNoteModal(props) {

  const [prevalue, setPreValue] = useState(props.existing_value);
  const editorRef               =   useRef(null);
  return (
    <div className={`${PageStyle.SetupPopup}`}>
  
      <div className={`${PageStyle.SetupPopup__inner} ${RejectModalStyle.RejectModal__inner}`}>
        
        <div className={`${PageStyle.OtpBacksection2} ${RejectModalStyle.OtpBacksection2}`}>
          <div className={`${PageStyle.Otpback} ${RejectModalStyle.Otpback}`}>
            <Button
              buttonstyle={PageStyle.nobgbutton}
              type="button"
              onClick={()=>  props.setModal({status: false, index: props.modal.index, heading: '', submitButtonAction:''})}
            >
              Close
            </Button>
          </div>
        </div>
    
        <div className={`${PageStyle.SetupPopup__Content} ${RejectModalStyle.RejectModal__Content}`}>
       		 	<div className={`${PageStyle.Sharecv__Heading}`}>
            		<h1>{props.modal.heading}</h1>
         		</div>
        
  
                {props.label && <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.mt15} ${RejectModalStyle.RejectModal__ContentBlock}`}>
                  <label>{props.label}</label>
                </div>}

                <div className={`${PageStyle.SetupPopup__ContentBlock} mt25`}>

                {props.text_area_type == 'custom_editor' ?
                                                        <FormikControl
                                                          control="customtextarea"
                                                          type="text"
                                                          formik={props.formik}
                                                          className    = {`${PageStyle.Form__Textarea} width100`}
                                                          rows         =   "7"
                                                          placeholder  = {t('placeholder:write_here')}
                                                          style        = {InputError(props.formik, props.name)}
                                                          disabled     = {!props.editable}
                                                          name         = {"notes"}
                                                          defaultValue = {prevalue}
                                                          onChange     = {(event)=>{setPreValue(event.target.value)}}
                                                        />
                                                    : <FormikControl
                                                          control="customtextarea"
                                                          type="text"
                                                          formik={props.formik}
                                                          className    = {`${PageStyle.Form__Textarea} width100`}
                                                          rows         =   "7"
                                                          placeholder  = {t('placeholder:write_here')}
                                                          style        = {InputError(props.formik, props.name)}
                                                          disabled     = {!props.editable}
                                                          name         = {"notes"}
                                                          defaultValue = {prevalue}
                                                          onChange     = {(event)=>{setPreValue(event.target.value)}}
                                                        />}
                </div>
                

                <div className={`${PageStyle.SetupPopup__SubmitSectionSave} ${RejectModalStyle.RejectModal__SubmitSectionSave}`}>
                  <Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={()=> {props.setModal({  status: false, 
                                                                                                                    index: props.modal.index, 
                                                                                                                    heading: '', 
                                                                                                                    submitButtonAction: ''})}}> Cancel </Button>

                  <Button disabled= {!props.editable} buttonstyle={ComponentStyle.primarybtn} onClick={()=>{props.modal.submitButtonAction({setModal: props.setModal, 
                                                                                                                                            index: props.modal.index, 
                                                                                                                                            value: prevalue,
                                                                                                                                            formik:props.formik,
                                                                                                                                            name: props.name})}}> Submit</Button> 
                </div>
  		</div>

      </div>
    </div>
  )

}
